import { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

const TabParamsContext = createContext<Record<string, string> | null>(null);

export const TabParamsProvider = TabParamsContext.Provider;

/**
 * Drop-in replacement for useParams().
 * When rendered inside a TabParamsProvider (desktop tab), reads from context.
 * Otherwise falls back to react-router's useParams (mobile Outlet rendering).
 */
export function useTabParams<T extends Record<string, string> = Record<string, string>>(): T {
  const tabParams = useContext(TabParamsContext);
  const routerParams = useParams();

  // If we have tab params (rendered inside TabRenderer), use those
  if (tabParams !== null && Object.keys(tabParams).length > 0) {
    return tabParams as T;
  }
  // Otherwise fall back to router params (rendered inside Outlet)
  return routerParams as T;
}
